export default {
    palette: {
      primary: {
        light: "#50a9fd",
        main: "#3b82c6",
        dark: "#2363a1",
        contrastText: "#fff"
      },
      secondary: {
        light: "#ff4081",
        main: "#f50057",
        dark: "#005eda",
        contrastText: "#fff"
      }
    },
    typography: {
      useNextVariants: true
    },
    // form: {
    //   textAlign: "center"
    // },
    // image: {
    //     margin: "20px auto 20px auto",
    //     width: "100px"
    // },
    // pageTitle: {
    //     margin: "10px auto 10px auto"
    // },
    // textField: {
    //     margin: "10px auto 10px auto"
    // },
    // button: {
    //     marginTop: 20,
    //     position: "relative"
    // },
    // customError: {
    //     color: "red",
    //     fontSize: "0.8rem"
    // },
    // progress: {
    //     position: "absolute"
    // },
    // signupRedirect: {
    //     color: "#5252d4",
    // }
  }